let VideoModal = function () {
    // Stop Video on modal play
    const update_iframe_src = function ($target, $play) {
        var $frames = $($target).find('iframe');
        if ($frames) {
            $frames.each(function (e) {
                if ($play) {
                    var src = $(this).attr('data-src');
                    $(this).attr('src', src);
                } else {
                    var src = $(this).attr('src');
                    $(this).attr('src', '').attr('data-src', src);
                }
            });
        }
    }
    $('.video-modal').on('shown.bs.modal', function (e) {
        const video = $(this).find('video');
        const modal = $(e.delegateTarget);
        update_iframe_src(modal, true)
        if (video.length > 0) {
            video[0].play();
        }
    });
    $('.video-modal').on('hidden.bs.modal', function (e) {
        const video = $(this).find('video');
        const modal = $(e.delegateTarget);
        update_iframe_src(modal, false);
        if (video.length > 0) {
            video[0].pause();
        }
    });
    // let youtube = document.querySelectorAll('#youtube_player');
    // let vimeo = document.querySelectorAll('#vimeo_player');

    //  // Play and Pause Video Modal
    // const handleVideoPausePlay = function ($target, $play) {
    //     let playAllVideos = () => { 
    //         let modal = document.querySelectorAll('.video-modal');
    //         modal.forEach(iframe => {
    //             iframe = iframe.querySelector('iframe');
    //             if (youtube.length > 0) {
    //                 iframe.contentWindow.postMessage(JSON.stringify(
    //                     { event: 'command', func: 'playVideo' }
    //                 ), '*');
    //             }
    //             if (vimeo.length > 0) {
    //                 var player = new Vimeo.Player(iframe);
    //                 player.play();
    //             }
    //         });
    //     }
        
    //     let pauseAllVideos = () => { 
    //         let modal = document.querySelectorAll('.video-modal');
    //         modal.forEach(iframe => {
    //             iframe = iframe.querySelector('iframe');
    //             if (youtube.length > 0) {
    //                 iframe.contentWindow.postMessage(JSON.stringify(
    //                     { event: 'command', func: 'pauseVideo' }
    //                 ), '*');
    //             }
    //         });
    //     }
        
    //     const $frames = $($target).find('iframe');
    //     if ($frames) {
    //         $frames.each(function (e) {
    //             if ($play) {
    //                 playAllVideos();
    //             } else {
    //                 pauseAllVideos();
    //             }
    //         });
    //     }
    //     const video = $(this).find('video');
    //     if (video.length > 0) {
    //         if( $play ) {
    //         video[0].play();
    //         }else{
    //         video[0].pause();
    //         }
    //     }
    // }
    // $('.video-modal').on('shown.bs.modal', function (e) {
    //     const modal = $(e.delegateTarget);
    //     handleVideoPausePlay(modal, true);
    // });
    // $('.video-modal').on('hidden.bs.modal', function (e) {
    //     const modal = $(e.delegateTarget);  
    //     handleVideoPausePlay(modal, false);
    // });
}

export default VideoModal;